import {useEffect, useRef, useState} from 'react';

export default function useViewportVisibility() {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const [entered, setEntered] = useState(() => typeof window !== 'undefined' && !window.IntersectionObserver);

    useEffect(() => {
        if (!window.IntersectionObserver || !ref.current) return;
        const observer = new IntersectionObserver(([entry]) => {
            setVisible(entry.isIntersecting);
            if (entry.isIntersecting) setEntered(true);
        }, {rootMargin: '150px 0px'});
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return {ref, visible, entered};
}
